import { AssetAllocationSection } from '@/features/service-desk/components/AssetAllocationSection'

export default function AssetAllocationPage() {
  return <AssetAllocationSection />
}
